// @flow
import { connect } from 'react-redux';

import { createNewConversation, updateElectronCaptionMode } from '../../../actions';
import { setCCMode, setShowBubbleAboveCCMode } from '../../../actions/cc-mode';

import HomeView from './HomeView';

const mapStateToProps = ({ ccMode: { showBubbleAboveCCMode } }) => ({
  showBubbleAboveCCMode,
});

const mapDispatchToProps = {
  createNewConversation,
  setCCMode,
  setShowBubbleAboveCCMode,
  updateElectronCaptionMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeView);
